import { StyleSheet } from 'react-native'

export const OwnerReviewStyles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginTop: 15,
  },
  properties: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    marginLeft: 10,
    marginTop: 9,
    width: '80%',
  },
  ownerName: {
    fontSize: 16,
    fontWeight: '700',
  },
  propertyText: {
    fontSize: 16,
    lineHeight: 26,
  },
  editButtonContainer: {
    marginLeft: 'auto',
    flex: 1,
    maxWidth: 70,
    marginRight: -10,
  },
})
